import { memo } from "react";

import { SiteLogo } from "@/components";
import { HEADER_HEIGHT } from "@/constants";

const HEADER_STYLE = { height: HEADER_HEIGHT };

function MinimalHeader() {
  return (
    <div
      className="py-2.5 px-[18px] flex items-center justify-center bg-white dark:bg-gradient-to-b from-blue-1 to-black gap-2.5 max-mob:p-2.5 sticky top-0 z-[100]"
      style={HEADER_STYLE}
      data-testid="MinimalHeader"
    >
      <SiteLogo type="logo" className="h-[22px]" />
    </div>
  );
}

export default memo(MinimalHeader);
